module.exports = __webpack_public_path__ + "img/used4.96ab09aa.webp";